import type { PlayerRef, TPlayer } from '@setplex/pureya'
import type { RefObject } from 'react'

import { useRef } from 'react'

export type UsePlayer = {
  ref: RefObject<PlayerRef | null>
  instance?: TPlayer
  wrapper?: HTMLDivElement
  container?: HTMLDivElement
  events: {
    on?: PlayerRef['on']
    off?: PlayerRef['off']
  }
}

/**
 * Player hook,
 * Encapsulates commonly used player methods and properties
 */
export function usePlayer(): UsePlayer {
  const ref = useRef<PlayerRef>(null)

  const on = ref.current?.on
  const off = ref.current?.off
  const instance = ref.current?.player() || undefined
  const wrapper = ref.current?.wrapper() || undefined
  const container = ref.current?.container() || undefined

  return {
    ref,
    instance,
    wrapper,
    container,
    events: {
      on,
      off,
    },
  }
}
